import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userCookie } from '~/models/UserCookie.js';
import * as shoppingCartActions from '~/store/legacy/actions/shoppingCartActions';
import * as userActions from '~/store/legacy/actions/userActions';
import * as shoppingCartSelectors from '~/store/legacy/selector/shoppingCartSelectors';
import { selectUser, selectUserAddress } from '~/store/legacy/selector/userSelectors';
import ShoppingCartBox from './ShoppingCartBox.jsx';

export default ShoppingCartDropdown;

/**
 * Display of the cart in the dropdown from the app toolbar
 */
function ShoppingCartDropdown() {
  const dispatch = useDispatch();
  const isUserLoggedIn = userCookie.isLoggedIn;
  const user = useSelector(selectUser);
  const { address } = useSelector(selectUserAddress);
  const { time, timeLoaded, addressId: shoppingCartAddressId } = useSelector(
    shoppingCartSelectors.selectShoppingCartData
  );
  const meals = useSelector(shoppingCartSelectors.selectMeals);

  useEffect(() => {
    if (isUserLoggedIn && !timeLoaded) {
      dispatch(shoppingCartActions.getDeliveryTimes());
    }
  }, [isUserLoggedIn, timeLoaded]);

  useEffect(() => {
    // if no shoppingCart addressId means user
    // add to cart before selecting a saved address
    if (isUserLoggedIn && !shoppingCartAddressId) {
      if (address) {
        dispatch(userActions.setNewUserSearchAddress(address));
      }
    }
  }, [isUserLoggedIn, shoppingCartAddressId]);

  const checkoutTotal = async () => {
    if (
      isUserLoggedIn &&
      timeLoaded &&
      shoppingCartAddressId &&
      user.phone_number &&
      user.verified
    ) {
      await dispatch(shoppingCartActions.checkout());
    }
  };

  useEffect(() => {
    checkoutTotal();
  }, [meals, isUserLoggedIn, timeLoaded, time, shoppingCartAddressId]);


  return <ShoppingCartBox buttonText='Check out' meals={meals} />;
}
